export default __webpack_public_path__ + "static/media/sip-img.6109358f.svg";